module.exports = __webpack_public_path__ + "static/media/banner-clients-04-mobile.8715cf63.jpg";